import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';

const GUIDE_EMBED_URL =
    'https://nordinsight.notion.site/ebd/1f130b1bf6c6807d83abd13968b887b5';
const GUIDE_PAGE_URL =
    'https://nordinsight.notion.site/1f130b1bf6c6807d83abd13968b887b5';

// The Notion embed is memory-heavy enough that WebKit repeatedly kills the
// page ("A problem repeatedly occurred"), so Safari gets a link-out instead.
function isSafari(): boolean {
    const ua = navigator.userAgent;
    return /safari/i.test(ua) && !/chrome|chromium|crios|fxios|edg|android/i.test(ua);
}

const UltimateGuidePage = () => {
    const { t } = useTranslation();
    const safari = useMemo(isSafari, []);

    if (safari) {
        return (
            <div className="flex h-full w-full items-center justify-center p-6">
                <div className="max-w-md space-y-4 rounded-lg border border-white/10 bg-white/[0.03] p-8 text-center">
                    <h2 className="text-lg font-semibold">
                        {t('guide.fallbackTitle')}
                    </h2>
                    <p className="text-sm text-muted-foreground">
                        {t('guide.fallbackDescription')}
                    </p>
                    <Button asChild>
                        <a
                            href={GUIDE_PAGE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('guide.fallbackOpen')}
                            <ExternalLink className="ml-2 h-4 w-4" />
                        </a>
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="h-full w-full">
            <iframe
                src={GUIDE_EMBED_URL}
                title={t('guide.iframeTitle')}
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
            />
        </div>
    );
};
export default UltimateGuidePage;
